import React, { useState, useEffect, useCallback } from "react";
import Pagination from "@material-ui/lab/Pagination";
import PaginationItem from "@material-ui/lab/PaginationItem";

import "./courses.scss";
import CourseItem from "./components/CourseItem";
import CourseService from "../../../../services/CoursesService";
import ProfilesService from "../../../../services/ProfilesService";
import { Link, useLocation } from "react-router-dom";
import { calcCountPages, calcOffset } from "../../../../utils/pagination";
import EmptyResult from "../../../components/EmptyResult";
import ScreenHeader from "../../components/ScreenHeader";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import ModalAddNewCourse from "./modals/modalNewCourse";
import { useSelector } from "react-redux";
import SearchBox from "../../../components/SearchBox/SearchBox";

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function CourseScreen(props) {  

  const coursesLoading = Array.from(Array(5).keys());
  const [courses, setCourses] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModalAddNewCourse, setOpenModalAddNewCourse] = useState(false);  
  const { user } = useSelector( state => state );

  // pagination
  const location = useLocation();
  let query = useQuery();
  const [countPages, setCountPages] = useState(0);
  const page = parseInt(query.get("page")) || 1;
  const paginationLimit = 5;

  // Query Params
  const openedCourseId = parseInt(query.get("openedCourseId")) || null;

  const fetchCoursesData = useCallback(async (value) => {
    setIsLoading(true);
    try {
      const result = await CourseService.listCourses({
        fields: "id,name,teachers,modified_datetime,description,required_books,occurrences,office_hours,start_date,end_date,location,category",
        
        limit: paginationLimit,
        offset: calcOffset(page, paginationLimit),        
      }, {name__icontains: value} );
      setCourses(result.data.results);
      setCountPages(calcCountPages(result, paginationLimit));
      setIsLoading(false);
    } catch (error) {
      setCourses([]);
    }
  }, [page]);

  const fetchTeachersData = useCallback(async () => {    
    setIsLoading(true);
    try {
      const result = await ProfilesService.listProfiles({
        fields: "id,first_name,last_name",
        limit: 'no_paginate'
      },{
        profile: 'teacher'
      });
      setTeachers(result.data.results);
      setIsLoading(false);
    } catch (error) {
      console.log("Error", error)
      setTeachers([]);
    }
  }, []);

  const removeCourseFromList = courseId => {
    const NewCourses = courses.filter((item, index) => item.id !== courseId);
    setCourses(NewCourses);
  };

  const updateCourseFromList = () => {    
    fetchCoursesData();        
  };

  useEffect(() => {
    // Query Params changued
    fetchCoursesData();
    fetchTeachersData();
  }, [fetchCoursesData, fetchTeachersData, location.search]);

  const handleClickOpenModalAddNewCourse = () => {
    setOpenModalAddNewCourse(true);
  };

  const handleClickCloseModalAddNewCourse = () => {
    setOpenModalAddNewCourse(false);
  };

  const updateCourseInfo = (courseId, data) => {
    const NewCourses = courses.map((item, index) => {
      if (item.id === courseId) {
        return data;
      }
      return item;
    });
    setCourses(NewCourses);
  };

  return (
    <div
      id="course-screen"
      className={`${props.className} dashboard-container`}
    >
      {/* Header */}
      <ScreenHeader title="Groups">        
        {user && user.data.profile === 'manager' ?
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClickOpenModalAddNewCourse}
            endIcon={<AddIcon />}
          >
            {" "}
            Add Group
          </Button>
        : null}
        {/* <IconButton color="primary" aria-label="add course" component="span">
          <AddIcon />
        </IconButton> */}
      </ScreenHeader>

      {/* Body */}
      <div className="content">
        <SearchBox fetchData={fetchCoursesData} placeholder="Search Group" />

        <div className="courses-list" style={{ minHeight: "36em" }}>
          {isLoading ? (
            // Generate 5 courses of loading data
            coursesLoading.map(i => <CourseItem key={i} loading />)
          ) : // Show courses
          courses.length > 0 ? (
            courses.map(course => (
              <CourseItem
                data={course}
                key={course.id}
                removeCourse={removeCourseFromList}
                updateCourseFromList={updateCourseInfo}
                openSnack={props.openSnack}
                listTeachers={teachers}
                isExpanded={openedCourseId === course.id}
                page={page}
              />
            ))
          ) : (
            // Show Empty courses
            <EmptyResult />
          )}
        </div>
        <Pagination
          page={page}
          count={countPages}
          color="primary"
          size="large"
          renderItem={item => (
            <PaginationItem
              component={Link}
              to={`/dashboard/courses${
                item.page === 1 ? "" : `?page=${item.page}`
              }`}
              {...item}
            />
          )}
        />
      </div>

      {/* Modal Dialog for Remove Data */}
      <ModalAddNewCourse
        open={openModalAddNewCourse}
        onClose={handleClickCloseModalAddNewCourse}
        updateCourseFromList={updateCourseFromList}
        listTeachers={teachers}
      />
    </div>
  );
}

export default CourseScreen;
